import { registerNotificationKind } from '../registry.js';
/**
 * Module 50's notification kinds (spec 50 §4.5, S50-6): recipients and link
 * targets per the table there. `data.content_item_id` is present on all but `weekly_approval`.
 */
export const CONTENT_SUBMITTED = 'content_submitted';
export const CHANGES_REQUESTED = 'changes_requested';
export const APPROVAL_REVOKED = 'approval_revoked';
export const PUBLICATION_REMINDER = 'publication_reminder';
export const WEEKLY_APPROVAL = 'weekly_approval';
registerNotificationKind({
    kind: CONTENT_SUBMITTED,
    i18nKey: 'notifications.kind.content_submitted',
    mailTemplate: 'content_submitted',
    linkTarget: (data) => `/review/${String(data.content_item_id)}`,
});
registerNotificationKind({
    kind: CHANGES_REQUESTED,
    i18nKey: 'notifications.kind.changes_requested',
    mailTemplate: 'changes_requested',
    linkTarget: (data) => `/content/${String(data.content_item_id)}`,
});
registerNotificationKind({
    kind: APPROVAL_REVOKED,
    i18nKey: 'notifications.kind.approval_revoked',
    mailTemplate: 'approval_revoked',
    linkTarget: (data) => `/review/${String(data.content_item_id)}`,
});
/**
 * Reminder sweep (S6, spec 50 §4.5, REQ-50-013): `data.content_status` decides
 * the link, matching the recipient split (`content:approve` for `in_review`
 * gets the review queue, everyone else the editor view of the item).
 */
registerNotificationKind({
    kind: PUBLICATION_REMINDER,
    i18nKey: 'notifications.kind.publication_reminder',
    mailTemplate: 'publication_reminder',
    linkTarget: (data) => (data.content_status === 'in_review' ? `/review/${String(data.content_item_id)}` : `/content/${String(data.content_item_id)}`),
});
/**
 * Weekly approval (S160-1, REQ-AUT-001): one message per approver and week
 * with the posts of the next seven days that wait for approval;
 * `data.count`, `data.content_titles`, `data.week_start` (tenant-local date).
 */
registerNotificationKind({
    kind: WEEKLY_APPROVAL,
    i18nKey: 'notifications.kind.weekly_approval',
    mailTemplate: 'weekly_approval',
    linkTarget: () => '/review/week',
});
//# sourceMappingURL=50.js.map